import { useDiscountDescriptor } from 'routes/Menu/components/BoxSummary/Banner/PriceAndDiscountTip/priceAndDiscountTipUtils'

import { formatDiscountTip } from './discountAppliedBarUtils'

export const DISCOUNT_TEXT = {
  default: {
    title: 'Discount applied:',
    body: 'off first order',
  },
} as const

export const useDiscountAppliedData = () => {
  const discountDescriptor = useDiscountDescriptor()
  const { isDiscountEnabled } = discountDescriptor

  const discountAmount = formatDiscountTip(discountDescriptor)

  const { title: discountAppliedTitle, body: discountAppliedBody } = DISCOUNT_TEXT.default

  if (!isDiscountEnabled) {
    return {
      discountAppliedTitle: null,
      discountAppliedBody: null,
      discountAmount: null,
      isDiscountEnabled,
    }
  }

  return {
    discountAppliedTitle,
    discountAppliedBody,
    isDiscountEnabled,
    discountAmount,
  }
}
